import { Flex } from 'antd'
import React, { ReactNode } from 'react'
import { styled } from 'styled-components'
import { BurgerButton } from './components/BurgerButton'
import { Constants } from './constants'

const WIDTH_BURGER = 48

const Wrapper = styled(Flex)<{
  $isOpen: boolean
  $width: string
  $isShadow: boolean
  $shadowColor: string
  $background: string
  $offsetToggle: string
}>`
  position: relative;

  .leftbar__body {
    position: relative;
    min-width: ${props => props.$width};
    overflow: hidden;
    opacity: 1;
    background: ${props => props.$background};

    transition:
      opacity ${Constants.CSS_TRANSITION},
      width ${Constants.CSS_TRANSITION},
      min-width ${Constants.CSS_TRANSITION},
      transform ${Constants.CSS_TRANSITION};

    .leftbar__body-content {
      position: absolute;
      min-width: ${props => props.$width};

      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: -4px; // Push the shadow to the right
        width: 4px; // Width of the shadow effect
        height: 100%;
        ${props =>
          props.$isShadow
            ? `box-shadow: -4px 0 10px ${props.$shadowColor};`
            : ''};
        pointer-events: none; // Ensure it doesn't interfere
      }
    }
  }

  .leftbar__burger-placeholder {
    width: ${WIDTH_BURGER}px;
    height: 32px;
  }

  .leftbar__burger {
    transition: transform ${Constants.CSS_TRANSITION};
    position: absolute;
    right: 0;
    z-index: 1;
    transform: translateX(0);
  }

  ${({ $isOpen, $offsetToggle }) => {
    if ($isOpen) {
      return `

        `
    } else {
      return `
        .leftbar__body {
          width: 0px;
          min-width: 0px;
          opacity: 0;
        }

        .leftbar__burger {
          transform: translateX(${$offsetToggle});
        }
      `
    }
  }}
`

type Props = {
  isOpen: boolean
  width: string
  offsetToggle?: string
  isShadow?: boolean
  background?: string
  shadowColor?: string
  children: ReactNode
  header?: ReactNode
  onClick: () => void
}

export const LeftbarDrawer: React.FC<Props> = ({
  isOpen,
  children,
  width,
  background = '#fcfcfc',
  offsetToggle = '100%',
  shadowColor,
  isShadow = true,
  header,
  onClick,
}) => {
  return (
    <Wrapper
      $isOpen={isOpen}
      $width={width}
      $isShadow={isShadow}
      $shadowColor={shadowColor}
      $background={background}
      $offsetToggle={offsetToggle}
    >
      <Flex
        className="leftbar__body"
        vertical
        style={{
          height: 'var(--100vh)',
        }}
      >
        <Flex vertical className="h-full w-full leftbar__body-content">
          <Flex className="w-full">
            {header}
            <div className="leftbar__burger-placeholder" />
          </Flex>

          <Flex flex={1} vertical>
            {children}
          </Flex>
        </Flex>
      </Flex>

      <Flex className="leftbar__burger p-2">
        <BurgerButton isOpen={isOpen} onClick={onClick} />
      </Flex>
    </Wrapper>
  )
}
